import { Controller } from '@hotwired/stimulus';
import { template } from 'lodash';

export default class extends Controller {
  static targets = [
    'title',
    'hasConditions',
    'conditionFormTemplate',
    'container',
    'formsContainer',
    'addConditionBtn',
    'destroyTemplate',
    'newOptionTemplate',
    'conditionOptionDestroyTemplate'
  ];

  initialize() {
    this.CONDITION_LIMIT = 10;
    this.DISPLAY_OPTION_CLOSE_BTN_LIMIT = 3 // only show close button when options are 3 or above
    this.conditionOptions = {}
    this.conditionFormTemplate = template(this.conditionFormTemplateTarget.innerHTML);
    this.newOptionTemplate = template(this.newOptionTemplateTarget.innerHTML);
    this.destroyTemplate = template(this.destroyTemplateTarget.innerHTML);
    this.conditionOptionDestroyTemplate = template(this.conditionOptionDestroyTemplateTarget.innerHTML);
  }

  connect() {
    this.toggleProductCondition();
    this.currentIndex = parseInt(this.containerTarget.dataset.currentIndex);
  }

  toggleProductCondition = () => {
    if (this.hasConditionsTarget.checked) {
      this.containerTarget.classList.remove('hidden');
    } else {
      this.containerTarget.classList.add('hidden');
    }
  }

  addCondition = event => {
    event.preventDefault();
    if (this.titleTargets.length >= this.CONDITION_LIMIT) return;

    this.currentIndex += 1;
    this.formsContainerTarget.insertAdjacentHTML(
      'beforeend',
      this.conditionFormTemplate({ conditionIndex: this.currentIndex })
    );
    this.restrictProductConditions();
    this.redisplayConditionTitles();
  }

  deleteCondition = event => {
    event.preventDefault();
    if (!confirm('Are you sure you want to remove this condition?')) return; // eslint-disable-line no-alert

    const { index } = event.target.dataset;
    document.getElementById(`conditionsForm-${index}`).remove();
    this.formsContainerTarget.insertAdjacentHTML(
      'beforeend',
      this.destroyTemplate({ index: parseInt(index) - 1 })
    );
    this.restrictProductConditions();
    this.redisplayConditionTitles();
  }

  onAddConditionOption = event => {
    event.preventDefault();

    const { conditionId, lastOptionId } = event.target.dataset;
    this.addOption(conditionId, lastOptionId);
  }

  onConditionTypeChanged = event => {
    const { containerId, conditionId } = event.target.dataset
    const container = document.getElementById(containerId);
    const { value } = event.target;

    if (value === 'Beachy::Model::ListProductCondition') {
      this.addDefaultOptions(conditionId);
      container.classList.remove('hidden');
    } else {
      container.classList.add('hidden');
    }
  }

  deleteConditionOption = event => {
    event.preventDefault();
    if (!confirm('Are you sure you want to remove this option?')) return; // eslint-disable-line no-alert

    const { conditionIndex, optionIndex } = event.target.dataset
    const optionContainer = document.getElementById(`conditionOptionsForm-${conditionIndex}`);

    document.getElementById(`options-${conditionIndex}-${optionIndex}`).remove();
    optionContainer.insertAdjacentHTML('beforeend', this.conditionOptionDestroyTemplate({ optionIndex, conditionIndex }));
    this.redisplayConditionOptionTitles(conditionIndex);
    this.displayCloseBtns(conditionIndex);
  }

  addOption(conditionIndex, lastOptionId, placeholder = '') {
    const inputContainer = document.getElementById(`conditionOptionsInput-${conditionIndex}`);

    this.conditionOptions[conditionIndex] ||= { lastOptionId: parseInt(lastOptionId) }
    const optionIndex = this.conditionOptions[conditionIndex].lastOptionId + 1

    inputContainer.insertAdjacentHTML('beforeend', this.newOptionTemplate({ optionIndex, conditionIndex, placeholder }));

    this.conditionOptions[conditionIndex].lastOptionId += 1;
    this.redisplayConditionOptionTitles(conditionIndex);
    this.displayCloseBtns(conditionIndex);
  }

  displayCloseBtns(conditionId) {
    const buttons = document.querySelectorAll(`#conditionOptionsInput-${conditionId} .close-btn`);

    if (this.optionsSize(conditionId) >= this.DISPLAY_OPTION_CLOSE_BTN_LIMIT) buttons.forEach(btn => btn.classList.remove('hidden'));
    else buttons.forEach(btn => btn.classList.add('hidden'));
  }

  addDefaultOptions(conditionId) {
    if (this.optionsSize(conditionId) > 0) return;

    this.addOption(conditionId, 0, 'Option 1');
    this.addOption(conditionId, 1, 'Option 2');
  }

  optionsSize(conditionId) {
    return document.querySelectorAll(`#conditionOptionsInput-${conditionId} .option-title`).length;
  }

  restrictProductConditions() {
    if (this.titleTargets.length < this.CONDITION_LIMIT) {
      this.addConditionBtnTarget.classList.remove('cursor-not-allowed');
    } else {
      this.addConditionBtnTarget.classList.add('cursor-not-allowed');
    }
  }

  redisplayConditionTitles() {
    let index = 1;

    for (const target of this.titleTargets) {
      target.innerHTML = `Condition #${index}`;
      index += 1;
    }
  }

  redisplayConditionOptionTitles(conditionId) {
    const titles = document.querySelectorAll(`#conditionOptionsInput-${conditionId} .option-title`);
    for (let index = 1; index <= titles.length; index += 1) {
      titles[index - 1].innerHTML = `Option ${index}`;
    }
  }
}
